"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.at = void 0;
const get_1 = require("./get");
const map_object_1 = require("./map-object");
exports.at = (object, paths) => Object.values(map_object_1.mapObject(paths, (path) => get_1.get(object, path)));
//# sourceMappingURL=at.js.map